<template>
  <DialogLayout class="sms-biz-teacher-message-push-detail"
                :title="`短信消息内容 - ${rowData.trueName}/${rowData.loginId}`"
                v-loading="loading"
                element-loading-text="数据加载中，请稍等...">
    <template v-if="detailInfo">
      <SmsBizMessagePushDetail :detail-info="detailInfo"></SmsBizMessagePushDetail>
    </template>
    <template v-else>
      <Hint v-if="!loading"
            type="error">
        <div>详情数据加载失败</div>
        <el-button type="text"
                   @click="loadDetailInfo">重新加载</el-button>
      </Hint>
    </template>
  </DialogLayout>
</template>

<script>
import DialogLayout from '../../../../../../../../widgets/DialogLayout'
import SmsBizMessagePushDetail from '../widget/detail'
import Hint from '../../../../../../../../elements/Hint'
export default {
  name: 'SmsBizTeacherMessagePushDetail',
  components: {
    DialogLayout,
    SmsBizMessagePushDetail,
    Hint
  },
  props: {
    rowData: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      detailInfo: null
    }
  },
  methods: {
    loadDetailInfo () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/message/sms/teacher/detailInfo',
        method: 'post',
        data: this.$qs.stringify({
          postId: this.rowData.id
        })
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.detailInfo = response.data['detailInfo'] || {}
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('教学点数据加载失败')
      }).finally(() => {
        this.loading = false
      })
    }
  },
  mounted () {
    this.loadDetailInfo()
  }
}
</script>

<style lang="scss">
  .sms-biz-teacher-message-push-detail {
    width: 540px;
    max-width: 100%;
  }
</style>
